<template>
    <layout-main>
        <!-- CONTENT TO MOVE -->
        <Appointments></Appointments>
        <!--  -->
    </layout-main>
</template>

<script>
import LayoutMain from '@/views/layouts/Main.vue';
import Appointments from '@/components/appointment/booking/Appointments.vue';

export default {
    components: {
        'layout-main': LayoutMain,
        Appointments,
    },
    methods: {
    }
}
</script>
